<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0" v-if="sliderValue.length">
        <b-col>
          <span class="mr-2 filterText">Filter by Year: </span>
          <b class="mr-3">{{ sliderValueMinMax[0] }}</b>
          <b-form-slider
            ref="mySlider"
            :value="sliderValue"
            :min="min"
            :max="max"
            :range="sliderRange"
            @slide-stop="slideChange"
          ></b-form-slider>
          <b class="ml-3">{{ sliderValueMinMax[1] }}</b>
        </b-col>
        <b-col class="text-right">
          <downloadChart :commitName="'EBITDA'" />
          <div style="position: absolute;right: 216px;top: 7px;">
            <select @change="changeNormalCumulative" v-model="ebitdaNormalCumulative">
              <option value="normal">Normal</option>
              <option value="cumulative">Cumulative</option>
            </select> 
            
          </div>
        </b-col>
      </b-row>
      <b-row class="m-0 chartTabPanel autoCursor">
        <b-col ref="capture" style="padding:0;width:100%;overflow-x:auto">
          <!-- <p>{{ waterfallEBITDataNew }}</p> -->
          <Plotly
            :data="waterfallEBITDataNew"
            :layout="headcountLayout"
            :display-mode-bar="false"
            :config="config"
            ref="plotlyChart"
          ></Plotly> </b-col
      ></b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
import mixinCommon from "@/components/core/mixinCommon.vue";
export default {
  name: "EBITDA",
  components: {
    Plotly,
    bFormSlider,
    downloadChart,
  },
  mixins: [mixinCommon],
  computed: {
    ...mapGetters({
      waterfallebitda: "waterfallebitda",
      waterfall: "waterfall",
      isFullScreen: "isFullScreen",
      historyCalDropDown: "historyCalDropDown",
    }),
  },
  watch: {
    waterfall: {
      deep: true,
      handler() {
        this.waterfallChildren = this.waterfall.child
          ? this.waterfall.child
          : [];
        if (this.waterfallChildren && this.waterfallChildren.length) {
          let filterChart = this.waterfallChildren.filter(
            (item) => "Sales" === item.objectname
          );
          this.getChartDataById({
            id: filterChart[0].chartId,
            chartName: filterChart[0].objectname,
          });
          this.setDownloadInfo({
            fileName: "Waterfall_sales",
            downloadData: this.$refs.capture,
          });
        }
      },
    },
    waterfallebitda: {
      deep: true,
      handler() {
        if (this.waterfallebitda && this.waterfallebitda.length) {
          this.waterfallEBITData = JSON.parse(
            JSON.stringify(this.waterfallebitda)
          );
          this.chartDataHandler();
        }
      },
    },
  },
  data() {
    return {
      waterfallChildren: [],
      waterfallEBITData: [],
      waterfallEBITDataNew: [],
      ebitdaNormalCumulative: 'normal',
      chartTitle: "",
      sliderRange: true,
      sliderValueMinMax: [],
      headcountLayout: {
        height: 360,
        hovermode: !1,
        color: [
          "#4682B4",
          "#556B2F",
          "#DC143C",
          "#4682B4",
          "#C999CA",
          "#FDC381",
          "#C2E587",
          "#FDD7EA",
          "#E1E1E1",
          "#DB704C",
          "#FFA292",
          "#CEDCED",
          "#88B0E2",
          "#D65C33",
        ],
        margin: {
          l: "auto",
          r: "auto",
          b: 0,
          t: 0,
          //pad: 50
        },
        padding: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ntick: "auto",
          fixedrange: true,
          ticks: "outside",
          title:{text:"Parameters",standoff: 80,},
          tickfont: {
            size: 8 // Set the desired tick label size
          }
        },
        waterfallgroupgap: 0.5,
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          tickformat: ",",
          showzero: true,
          autorange: false,
          range:[0,250],
          nticks: 6,
          title: {
            text: "USD Millions",
            standoff: 40,
          },
        },
      },
      config: { responsive: true },
      sliderValue: [],
      min: 0,
      max: 0,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      EBITDA_ChartData: [],
    };
  },

  created() {},
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "currentVersionUpdateHandler",
      "getIframeChartDataById",
    ]),
    windowResize(e) {
      this.headcountLayout.width = this.$refs.capture.clientWidth - 50;
    },
    changeNormalCumulative(){
      if(this.ebitdaNormalCumulative=='normal'){
         this.waterfallEBITDataNew = this.waterfallEBITData
      }
      else {
        this.waterfallEBITDataNew = []
        let rx = []
        let ry = []
        let rtext = []
        let cumulativeData = {}
        for(let [i,d] of this.waterfallEBITData[0].x.entries()){
          let idx = d
          if(i != 0 && i != this.waterfallEBITData[0].x.length-1 ){
            if(d.includes('EBITDA')) continue
            idx = d.slice(0,d.length-5)
          } 
          if(cumulativeData[idx]){
            cumulativeData[idx] += this.waterfallEBITData[0].y[i] 
          }
          else {
            cumulativeData[idx] = this.waterfallEBITData[0].y[i] 
          }
        }
        for(let [i,d] of this.waterfallEBITData[0].x.entries()){
          let idx = d
          if(i != 0 && i != this.waterfallEBITData[0].x.length-1){
            if(d.includes('EBITDA')) continue
            idx = d.slice(0,d.length-5)
          } 
          if(!rx.includes(idx)){
            rx.push(idx)
          }
        }
        for(let [i,d] of rx.entries()){
          ry.push(cumulativeData[d])
          rtext.push(cumulativeData[d].toString())
        }
        let cdata = this.deepCopyOfData(this.waterfallEBITData);
        cdata[0].x =  rx
        cdata[0].y = ry
        cdata[0].text = rtext
        this.waterfallEBITDataNew = cdata
      }
    },
    deepCopyOfData(data) {
      return JSON.parse(JSON.stringify(data));
    },
    slideChange(e) {
      var chartData = this.deepCopyOfData(this.EBITDA_ChartData);
      this.sliderValueMinMax = [];
      this.sliderValueMinMax = [e[0], e[1]];
      let filterData = { x: [], y: [], measure: [], text: [] };
      let margin = 0;
      if (
        chartData &&
        chartData[0] &&
        chartData[0].x &&
        chartData[0].x.length
      ) {
        for (let i = 0; i < chartData[0].x.length; i++) {
          let yearString = chartData[0].x[i].replaceAll(".0", "");
          let xYear = yearString.substring(yearString.length - 4);
          if (
            parseInt(xYear) >= parseInt(e[0]) &&
            parseInt(xYear) <= parseInt(e[1])
          ) {
            if((chartData[0].x[i].includes(e[0])) && !(chartData[0].x[i].includes('EBITDA'))){
              continue
            }
            filterData.x.push(chartData[0].x[i]);
            filterData.y.push(chartData[0].y[i]);
            filterData.text.push(chartData[0].text[i]);
          }
        }
      }
      this.headcountLayout.yaxis.autorange = false
      this.headcountLayout.yaxis.range = [
        0,
        Math.max.apply(null, filterData.y) + 50
      ];
      this.waterfallEBITData[0].x = filterData.x;
      this.waterfallEBITData[0].y = filterData.y;
      this.waterfallEBITData[0].text = filterData.text;
     
      this.changeNormalCumulative()
    },
    async chartDataHandler() {
      var chartData = this.waterfallebitda;
      if (
        window.location.href.includes("auth_token=") &&
        !this.waterfallEBITData.length
      ) {
        let data = await this.getIframeChartDataById(188);
        chartData = this.deepCopyOfData(data);
        this.EBITDA_ChartData = data;
      } else {
        if (
          this.waterfallEBITData.length &&
          typeof this.waterfallEBITData != "string"
        ) {
          chartData = this.deepCopyOfData(this.waterfallEBITData);
          this.EBITDA_ChartData = chartData;
        }
      }
      this.waterfallEBITData = this.deepCopyOfData(chartData);
      this.headcountLayout.yaxis.autorange = false
      this.headcountLayout.yaxis.range = [
        0,
        Math.max.apply(null, this.waterfallEBITData[0].y)+50,
      ];
      this.changeNormalCumulative()
      let filterYearArr = [];
      let margin = 0;
      if (
        chartData &&
        chartData[0] &&
        chartData[0].x &&
        chartData[0].x.length
      ) {
        for (let i = 0; i < chartData[0].x.length; i++) {
          let tempMargin = chartData[0].x[i].length * 7;
          margin = margin >= tempMargin ? margin : tempMargin;
          let yearString = chartData[0].x[i].replaceAll(".0", "");
          let xYear = yearString.substring(yearString.length - 4);
          if (filterYearArr.length) {
            if (filterYearArr.indexOf(xYear) < 0) {
              filterYearArr.push(xYear);
            }
          } else {
            filterYearArr.push(xYear);
          }
          this.headcountLayout.margin.b = margin;
        }
        filterYearArr = filterYearArr.sort();
        this.sliderValueMinMax = [];
        this.sliderValueMinMax = [
          filterYearArr[0],
          filterYearArr[filterYearArr.length - 1],
        ];
      }
      this.min = "";
      this.max = "";
      this.min = parseInt(this.sliderValueMinMax[0]);
      this.max = parseInt(this.sliderValueMinMax[1]);
      this.sliderValue = [];
      this.sliderValue = [this.min, this.max];
    },
  },
  mounted() {
    // if (this.waterfallebitda && this.waterfallebitda.length) {
    this.chartDataHandler();
    // }
  },
  destroyed() {
    let payLoadObj = {
      table_pk: this.selected,
      chart_id: this.historyCalDropDown.current_version.chart_id,
      chartName: this.commitName,
    };
    let version = {
      version_data: payLoadObj,
      versionToggleValue: false,
    };
    this.currentVersionUpdateHandler(version);
  },
};
</script>

<style lang="scss">
.salesContainer {
  position: relative;
}
.js-plotly-plot{
  width:100%!important
}
</style>
